/** The website: the landing page (index.html, site/main.ts) and the game database (database/). */
export default {
  // ------------------------------------------------ header, footer
  Sections: "Bölümler",
  Nations: "Uluslar",
  "The Colony": "Koloni",
  War: "Savaş",
  Guides: "Rehberler",
  "Browser MMORPG": "Tarayıcı MMORPG",
  "Play on mobile": "Mobilde oyna",
  "PvP and war": "PvP ve savaş",
  "Online RPG": "Online RPG oyunu",
  "Free MMORPG": "Ücretsiz MMORPG",
  "Turkish MMORPG": "Türkçe MMORPG",
  FAQ: "SSS",
  "All news": "Tüm haberler",
  "Read more": "Devamını oku",
  "Back to all news": "Tüm haberlere dön",
  "Updates, events and maintenance notices from WarCrest Online.":
    "WarCrest Online'dan güncellemeler, etkinlikler ve bakım duyuruları.",
  "Post not found": "Haber bulunamadı",
  "Every hero starts somewhere. Make your own character in a minute and play in your browser, on a computer or a phone.":
    "Her kahraman bir yerden başlar. Bir dakikada kendi karakterini oluştur ve tarayıcında, bilgisayarda ya da telefonda oyna.",
  "Character not found": "Karakter bulunamadı",
  "This character's page is private": "Bu karakterin sayfası gizli",
  "Private character page | WarCrest Online": "Gizli karakter sayfası | WarCrest Online",
  "Character not found | WarCrest Online": "Karakter bulunamadı | WarCrest Online",
  "The player has made their characters' pages private, so there is nothing to show here.":
    "Oyuncu karakter sayfalarını gizli tuttuğu için burada gösterilecek bir şey yok.",
  "Go to the home page": "Ana sayfaya git",
  "Invite friends": "Arkadaşını davet et",
  "Your email is confirmed. Thank you!": "E-postan doğrulandı. Teşekkürler!",
  "This link is used or too old. Ask for a new one on your profile.":
    "Bu bağlantı kullanılmış ya da süresi geçmiş. Profilinden yenisini iste.",
  "Send the link again": "Bağlantıyı yeniden gönder",
  "Sent. Check your inbox and the spam folder.":
    "Gönderildi. Gelen kutunu ve spam klasörünü kontrol et.",
  "A link was sent a moment ago. Wait a couple of minutes before asking again.":
    "Az önce bir bağlantı gönderildi. Yeniden istemeden önce birkaç dakika bekle.",
  "Confirm your email": "E-postanı doğrula",
  "We sent a link to {email}. Confirm it to buy gems and so a friend who invited you gets their reward.":
    "{email} adresine bir bağlantı gönderdik. Elmas satın alabilmek ve seni davet eden arkadaşının ödülünü alabilmesi için doğrula.",
  "Your email, to confirm": "Onay için e-postan",
  "Password (if you have one)": "Şifre (varsa)",
  "Delete my account": "Hesabımı sil",
  "This deletes your account and every character on it, with their items, gold and gems. It cannot be undone. Records the law makes us keep, like payments, stay without your email.":
    "Bu, hesabını ve üzerindeki tüm karakterleri, eşyaları, altınları ve elmaslarıyla birlikte siler. Geri alınamaz. Ödemeler gibi kanunen saklamamız gereken kayıtlar e-postan olmadan kalır.",
  "Type your account's email exactly to confirm.":
    "Onaylamak için hesabının e-postasını aynen yaz.",
  "The password is wrong.": "Şifre yanlış.",
  "One of your characters is in the game. Leave the game first.":
    "Karakterlerinden biri oyunda. Önce oyundan çık.",
  "One of your characters leads a clan. Hand it over or disband it first.":
    "Karakterlerinden biri bir klanın lideri. Önce liderliği devret ya da klanı dağıt.",
  "One of your characters has a stall open. Close it first.":
    "Karakterlerinden birinin açık bir tezgâhı var. Önce onu kapat.",
  "You pay on Polar's secure page. Your gems arrive as soon as the payment is done.":
    "Ödemeyi Polar'ın güvenli sayfasında yaparsın. Ödeme biter bitmez elmasların gelir.",
  "Payment received: your gems arrive in a moment.": "Ödeme alındı: elmasların birazdan gelir.",
  "Buy gems": "Elmas satın al",
  "You can't buy gem packs until you confirm your email.":
    "E-postanı doğrulamadan elmas paketi satın alamazsın.",
  "Share pages": "Paylaşım sayfaları",
  "Your character pages are on.": "Karakter sayfaların açık.",
  "Your character pages are off: shared links show nothing.":
    "Karakter sayfaların kapalı: paylaşılan linkler bir şey göstermez.",
  "Turn them off": "Kapat",
  "Turn them on": "Aç",
  "Each character has a page you can share: its name, level, class, clan, NP and look. While off, the pages answer nothing and no picture of your characters is kept.":
    "Her karakterin paylaşabileceğin bir sayfası var: adı, seviyesi, sınıfı, klanı, NP'si ve görünüşü. Kapalıyken sayfalar hiçbir şey göstermez ve karakterlerinin resmi saklanmaz.",
  "When a friend signs up through your link and gets a character to level {level}, you both get {items}, for up to {max} friends.":
    "Bir arkadaşın senin linkinle kaydolup bir karakterini {level}. seviyeye çıkardığında ikiniz de şunları kazanırsınız: {items}. En fazla {max} arkadaş için geçerli.",
  "Your invite link": "Davet linkin",
  Copy: "Kopyala",
  Copied: "Kopyalandı",
  "Friends who signed up": "Kaydolan arkadaşlar",
  "Rewards earned": "Kazanılan ödüller",
  "Read the beginner's guide": "Başlangıç rehberini oku",
  "There is no character by this name on this server.": "Bu sunucuda bu isimde bir karakter yok.",
  "This post was removed, or it never existed.": "Bu haber kaldırıldı ya da hiç var olmadı.",
  "New here? Read the beginner's guide": "Yeni misin? Başlangıç rehberini oku",
  "Every skill of every class in the class guide": "Her sınıfın tüm becerileri sınıf rehberinde",
  "Read the PvP and war guide": "PvP ve savaş rehberini oku",
  Store: "Mağaza",
  News: "Haberler",
  Rankings: "Sıralama",
  Ranking: "Sıralama",
  Database: "Veritabanı",
  "Play now": "Hemen Oyna",
  "Play free": "Ücretsiz Oyna",
  "A browser MMORPG. No download.": "Tarayıcıda oynanan bir MMORPG. İndirme yok.",
  "Game database": "Oyun veritabanı",

  // ------------------------------------------------ hero
  "Knights of Valcrest and orcs of Gorzhak clash in front of the royal keep":
    "Valcrest şövalyeleri ile Gorzhak orkları kraliyet kalesinin önünde çarpışıyor",
  "Humans against orcs, in your browser. Level up in your homeland, then take the war to the Colony.":
    "Tarayıcında insanlar orklara karşı. Anavatanında seviye atla, sonra savaşı Koloni'ye taşı.",
  "Create an account": "Hesap oluştur",
  "No download. Runs on phones too.": "İndirme yok. Telefonlarda da çalışır.",
  "The WarCrest: Valcrest and Gorzhak on one shield":
    "WarCrest: Valcrest ve Gorzhak tek bir kalkanda",

  // ------------------------------------------------ live strip
  "Right now": "Şu an",
  Servers: "Sunucular",
  "Next world boss": "Sonraki dünya bossu",
  "Your account": "Hesabın",
  "any moment now": "her an",
  "in {h} h {m} min": "{h} sa {m} dk sonra",
  "in {m} min": "{m} dk sonra",
  "in 1 day": "1 gün sonra",
  "in {d} days": "{d} gün sonra",
  "in 1 day {h} h": "1 gün {h} sa sonra",
  "in {d} days {h} h": "{d} gün {h} sa sonra",
  "The {name} rises in {place}. Your local times:":
    "{name}, {place} içinde belirir. Senin saatinle:",
  "the Bowl": "Bowl",
  Full: "Dolu",
  Quiet: "Sakin",
  Busy: "Yoğun",
  Crowded: "Kalabalık",
  Open: "Açık",
  "The game servers cannot be reached right now.": "Oyun sunucularına şu an ulaşılamıyor.",

  // ------------------------------------------------ nations and classes
  "Pick a side": "Tarafını seç",
  "Every character belongs to one of two nations for life. You start together in Emberfold and go home at level 10.":
    "Her karakter ömür boyu iki ulustan birine aittir. Herkes Emberfold'da birlikte başlar ve 10. seviyede anavatanına döner.",
  "Four classes": "Dört sınıf",
  "Skills unlock as you level. Three stat points a level are yours to spend.":
    "Yetenekler seviye atladıkça açılır. Her seviyede harcaman için üç stat puanı kazanırsın.",
  "Stone keeps, blue banners and knights who hold the line: shields in front, healers close behind.":
    "Taş kaleler, mavi sancaklar ve hattı tutan şövalyeler: önde kalkanlar, hemen arkada şifacılar.",
  "Iron, tusks and red banners. The warbands camp among totems and smoke, and they never forget a grudge.":
    "Demir, azı dişleri ve kızıl sancaklar. Savaş birlikleri totemlerin ve dumanın arasında kamp kurar ve hiçbir kini unutmazlar.",
  "Human warriors, mages and priests in front of the keep of Valcrest":
    "Valcrest kalesinin önünde insan savaşçılar, büyücüler ve rahipler",
  "Orc warriors in the smoky war camp of Gorzhak":
    "Gorzhak'ın dumanlı savaş kampında ork savaşçılar",
  "Crown of {nation}": "{nation} Tacı",
  "Humans of Valcrest": "Valcrest İnsanları",
  "Orcs of Gorzhak": "Gorzhak Orkları",
  "Tank, melee": "Tank, yakın dövüş",
  "Damage, melee": "Hasar, yakın dövüş",
  "Damage, ranged": "Hasar, uzak menzil",
  "Healer, ranged": "Şifacı, uzak menzil",
  "Holds the front line. Cleaves, stuns and taunts.":
    "Ön hattı tutar. Yarar, sersemletir ve üzerine çeker.",
  "Burst damage. Poison, stealth and ambush.": "Ani yüksek hasar. Zehir, gizlenme ve pusu.",
  "Ranged caster. Fire, frost and a blink out of trouble.":
    "Uzaktan büyü yapar. Ateş, buz ve beladan kurtaran bir ışınlanma.",
  "Keeps the party alive. Mend, Prayer of Healing and Cure All.":
    "Partiyi ayakta tutar. Onarma, Şifa Duası ve Tam Arınma.",

  // ------------------------------------------------ the Colony
  "Players of both nations fight the Ancient Colossus in the Bowl":
    "İki ulusun oyuncuları Bowl'da Kadim Dev ile savaşıyor",
  "The Colony Zone": "Koloni Bölgesi",
  "From level 40 both nations meet in the Colony. Outside your base, anyone of the other nation is fair game. Every kill earns National Points: they rank you, and they buy cloaks from the quartermasters.":
    "40. seviyeden itibaren iki ulus Koloni'de karşılaşır. Üssünün dışında öteki ulustan herkes hedeftir. Her öldürme Ulusal Puan (NP) kazandırır: sıralamanı belirler ve levazımcılardan pelerin almanı sağlar.",
  "At the centre lies the Bowl, an arena inside a ruined wall. The Ancient Colossus rises there at set hours, and whoever holds the Bowl gets the first swing.":
    "Ortada, yıkık bir surun içindeki arena Bowl yer alır. Kadim Dev belli saatlerde orada belirir ve Bowl'u tutan ilk darbeyi vurur.",
  Levels: "Seviyeler",
  "1 to 60": "1 ile 60 arası",
  Homelands: "Anavatanlar",
  "Valcrest and Gorzhak, levels 10 to 40": "Valcrest ve Gorzhak, 10 ile 40. seviyeler arası",
  "Colony Zone": "Koloni Bölgesi",
  "Level 40 and up, open PvP": "40. seviye ve üzeri, açık PvP",
  "Parties and clans": "Partiler ve klanlar",
  "Up to 6 in a party, 30 in a clan": "Partide en fazla 6, klanda 30 kişi",
  Price: "Fiyat",
  "Free, in the browser": "Ücretsiz, tarayıcıda",

  // ------------------------------------------------ the war of Morgard
  "The War Keeper of Valcrest stands before its fort as both nations close in":
    "İki ulus yaklaşırken Valcrest'in Savaş Bekçisi kalesinin önünde duruyor",
  "The War of Morgard": "Morgard Savaşı",
  "Twice a week the gates to Morgard open. Each nation holds a fort at its end of the valley, and in each fort stands its War Keeper, a giant in the nation's colours. Cross the rivers, break through the other side's walls and bring their Keeper down: the first nation to do it wins the war.":
    "Haftada iki kez Morgard'ın kapıları açılır. Her ulusun vadinin kendi ucunda bir kalesi vardır ve her kalede ulusun renklerini taşıyan dev bir Savaş Bekçisi durur. Nehirleri geç, karşı tarafın surlarını yık ve Bekçisini devir: bunu ilk başaran ulus savaşı kazanır.",
  "The war is on. {n} min left": "Savaş sürüyor. {n} dk kaldı",
  "The gates to Morgard are open. Your local times:": "Morgard'ın kapıları açık. Senin saatinle:",
  "Next war {when}": "Sonraki savaş {when}",
  "Every week, in your local time:": "Her hafta, senin saatinle:",
  "{from} to {to}": "{from} - {to}",
  "Set by the server's clock: {time} {city} time.":
    "Sunucu saatine göre belirlenir: {city} saatiyle {time}.",
  "The winning nation earns {xp}% more experience, {gold}% more gold and {drop}% better drops until the next war, and its banner flies from the Victory Standard in Emberfold. While the war is on, the Colony Zone is closed and everyone there is sent home. When it ends, Morgard empties the same way.":
    "Kazanan ulus bir sonraki savaşa kadar %{xp} daha fazla tecrübe, %{gold} daha fazla altın ve %{drop} daha iyi drop kazanır, sancağı da Emberfold'daki Zafer Direği'nde dalgalanır. Savaş sürerken Koloni Bölgesi kapanır ve oradaki herkes eve gönderilir. Savaş bitince Morgard da aynı şekilde boşaltılır.",
  "{n} and up": "{n} ve üzeri",
  When: "Ne zaman",
  "{days}, {time} {city} time": "{days}, {city} saatiyle {time}",
  " and ": " ve ",
  Length: "Süre",
  "{n} h": "{n} sa",
  "{n} min": "{n} dk",
  "Way in": "Giriş",
  "Any travel gate. It shows faded while the war is closed":
    "Herhangi bir seyahat kapısı. Savaş kapalıyken soluk görünür",
  Victory: "Zafer",
  "Bring down the other nation's War Keeper": "Öteki ulusun Savaş Bekçisini devir",
  // ---- the Crystal Clash (index.html, site/main.ts)
  "The Crystal Clash": "Kristal Çatışması",
  "Six of each nation fight before the crystal inside its ruined ring":
    "İki ulustan altışar savaşçı, yıkık halkasının içindeki kristalin önünde çarpışıyor",
  "Twice a day the two nations meet in a small arena with a crystal at its heart. Sign up from the corner of the screen before it starts: at the start you are brought there with your nation's side, as one party, and your level decides which arena you fight in.":
    "Günde iki kez iki ulus, ortasında bir kristal olan küçük bir arenada karşılaşır. Başlamadan önce ekranın köşesinden kaydol: başlangıçta ulusunun tarafıyla, tek bir parti olarak oraya ışınlanırsın; hangi arenada savaşacağını seviyen belirler.",
  "Strike the last blow on the crystal and your nation wins at once. Otherwise the first side to {kills} kills wins, or the side with more kills when the {minutes} minutes run out.":
    "Kristale son vuruşu yaparsan ulusun hemen kazanır. Yoksa {kills} öldürmeye ilk ulaşan taraf, ya da {minutes} dakika dolduğunda daha çok öldürmesi olan taraf kazanır.",
  "Everyone who fights takes a coffer home: a {win} for the winners, a {lose} for the other side. Break it on the Riftstone Reel in Emberfold. Leaving early is free once a day; a second time keeps you out of the Clash for {hours} hours.":
    "Savaşan herkes eve bir sandıkla döner: kazananlara {win}, öteki tarafa {lose}. Sandığı Emberfold'daki Yarık Taşı Çarkı'nda kırarsın. Erken ayrılmak günde bir kez cezasızdır; ikincisinde {hours} saat boyunca Çatışma'ya katılamazsın.",
  Today: "Bugün",
  Tomorrow: "Yarın",
  "The Clash is on. {n} min left": "Çatışma sürüyor. {n} dk kaldı",
  "Sign-up is open: it starts {when}": "Kayıtlar açık: {when} başlıyor",
  "Next Clash {when}": "Sonraki Çatışma {when}",
  "Every day, in your local time:": "Her gün, senin saatinle:",
  "{a} to {b}": "{a} - {b}",
  ", each in its own arena": ", her biri kendi arenasında",
  "Every day, {times} {city} time": "Her gün, {city} saatiyle {times}",
  "Sign-up": "Kayıt",
  "{n} minutes before, from the corner of the screen": "{n} dakika önce, ekranın köşesinden",
  Sides: "Taraflar",
  "Up to {n} against {n}, each side one party": "En fazla {n}'ya {n}, her taraf tek parti",
  "Break the crystal or reach {n} kills": "Kristali kır ya da {n} öldürmeye ulaş",
  Sunday: "Pazar",
  Monday: "Pazartesi",
  Tuesday: "Salı",
  Wednesday: "Çarşamba",
  Thursday: "Perşembe",
  Friday: "Cuma",
  Saturday: "Cumartesi",

  // ------------------------------------------------ store
  "Power Up Store": "Power Up Mağazası",
  "Looks and time savers, bought with gems in the game. No weapons or armor are sold: gear comes from monsters, bosses and the anvil.":
    "Oyunda elmasla alınan görünümler ve zaman kazandıranlar. Silah ya da zırh satılmaz: teçhizat canavarlardan, bosslardan ve örsten gelir.",
  "Open the store in the game with the gem button on the bottom bar. Gems are shared by every character on your account, and what you buy with them cannot be sold or traded.":
    "Mağazayı oyunda alt çubuktaki elmas düğmesiyle aç. Elmaslar hesabındaki tüm karakterler arasında ortaktır ve elmasla aldıkların satılamaz ya da takas edilemez.",
  Wings: "Kanatlar",
  "Armor skins": "Zırh görünümleri",
  "Hand glows": "El parıltıları",
  "Gold Premium": "Gold Premium",
  "Fortune Stones": "Şans Taşları",
  Gems: "Elmaslar",
  gold: "altın",
  "{n} gems": "{n} elmas",
  "+{v}% {stat}": "+%{v} {stat}",
  "{n} days": "{n} gün",
  "{n} days, on every character": "{n} gün, tüm karakterlerinde",
  "Orbs of light on both hands": "İki elde ışık küreleri",
  "+{n}% experience from monsters": "Canavarlardan +%{n} tecrübe",
  "+{n}% gold from loot": "Ganimetten +%{n} altın",
  "+{n}% item drop chance": "+%{n} eşya drop şansı",
  "+{n}% NP from player kills": "Oyuncu öldürmelerinden +%{n} NP",
  "Priority entry when the server is full": "Sunucu doluyken öncelikli giriş",
  "No XP lost when a monster kills you": "Bir canavar seni öldürdüğünde XP kaybı yok",
  "For every character on your account": "Hesabındaki tüm karakterler için",
  "Use one at the blacksmith: that upgrade roll's success chance is {mult}x.":
    "Demircide bir tane kullan: o yükseltmenin başarı şansı {mult} katına çıkar.",
  "Gem packs are coming soon.": "Elmas paketleri yakında geliyor.",
  "Have an E-pin code?": "E-pin kodun mu var?",
  "Load an E-pin on your profile": "Profilinden E-pin yükle",
  "Load an E-pin": "E-pin yükle",
  Load: "Yükle",
  "An E-pin is 16 letters and digits, like ABCD-EFGH-JKMN-2345.":
    "E-pin, ABCD-EFGH-JKMN-2345 gibi 16 harf ve rakamdan oluşur.",
  "This code is not valid. Check it and try again.":
    "Bu kod geçerli değil. Kontrol edip tekrar dene.",
  "This code has already been used.": "Bu kod daha önce kullanılmış.",
  "Too many wrong codes. Try again in a few minutes.":
    "Çok fazla hatalı kod girildi. Birkaç dakika sonra tekrar dene.",
  "{n} gems loaded onto your account.": "Hesabına {n} elmas yüklendi.",
  "{gems} + {bonus} bonus": "{gems} + {bonus} bonus",
  "drop rate": "drop şansı",
  "No National Points this month yet.": "Bu ay henüz Ulusal Puan kazanılmadı.",
  "Monthly ranking rewards": "Aylık sıralama ödülleri",
  "The first of each nation of all time claims the {cloak} from the Herald in Hearthmoor and keeps it while holding the place: white silk and a golden crown, with twice the stats of the Cloak of the Paragon.":
    "Tüm zamanlarda her ulusun 1.'si {cloak} ödülünü Hearthmoor'daki Habercinden alır ve o sırada kaldığı sürece onda kalır: beyaz ipek ve altın taç, Kusursuzlar Pelerini'nin iki katı statla.",
  "Places in each nation's rankings show a symbol beside the name:":
    "Her ulusun sıralamalarındaki yerler ismin yanında bir simgeyle görünür:",
  "No National Points yet.": "Henüz Ulusal Puan kazanılmadı.",
  "Crimson velvet lined with ermine, edged in gold, a golden sun on the back. Gold sparks drift from the hem.":
    "Kakım kürkle astarlanmış, altın kenarlı kızıl kadife; sırtında altın bir güneş. Eteğinden altın kıvılcımlar süzülür.",
  "Midnight cloth woven with glowing stars, a silver crescent on the back. Starlight trails behind you.":
    "Parlayan yıldızlarla dokunmuş gece mavisi kumaş, sırtında gümüş bir hilal. Ardında yıldız ışığı bırakırsın.",
  "Charred black cloth split by burning runes, its hem a row of flames. Embers rise in your wake.":
    "Yanan rünlerle yarılmış kömür karası kumaş, eteği bir sıra alev. Geçtiğin yerden közler yükselir.",
  "Forest green with a collar of leaves, glowing vines and a hem of leaf points. Green motes drift around you.":
    "Yapraklı yakalı orman yeşili, parlayan sarmaşıklar ve yaprak uçlu bir etek. Etrafında yeşil ışık zerreleri süzülür.",
  "Blood-red plate with gold filigree, black horns and spiked shoulders. Embers rise from your armor.":
    "Altın telkârili kan kırmızısı zırh, siyah boynuzlar ve dikenli omuzluklar. Zırhından közler yükselir.",
  "Ice-blue plate crowned with glowing ice shards. Snowflakes circle you and frost rings your feet.":
    "Parlayan buz kristalleriyle taçlanmış buz mavisi zırh. Etrafında kar taneleri döner, ayaklarını kırağı halkası sarar.",
  "Royal gold with a winged helm and a sun on the chest. A golden halo floats over your head.":
    "Kanatlı miğferli, göğsünde güneş olan kraliyet altını zırh. Başının üstünde altın bir hale süzülür.",
  "A black cowl with burning violet eyes and shards of night on the shoulders. Dark smoke trails you.":
    "Yanan mor gözlü siyah bir kukuleta, omuzlarda gece kıymıkları. Ardında kara bir duman süzülür.",
  "Storm-blue plate with a lightning crest and conductor rods. Lightning crackles around you.":
    "Şimşek armalı, iletken çubuklu fırtına mavisi zırh. Etrafında şimşekler çatırdar.",

  // ------------------------------------------------ news and rankings
  Update: "Güncelleme",
  Event: "Etkinlik",
  Maintenance: "Bakım",
  Pinned: "Sabitlendi",
  "News could not be loaded. Try again in a moment.": "Haberler yüklenemedi. Birazdan tekrar dene.",
  "No news yet. The first posts arrive with launch.":
    "Henüz haber yok. İlk yazılar çıkışla birlikte gelecek.",
  "This month": "Bu ay",
  "All time": "Tüm zamanlar",
  Clans: "Klanlar",
  Name: "İsim",
  Class: "Sınıf",
  Level: "Seviye",
  Clan: "Klan",
  Nation: "Ulus",
  Members: "Üyeler",
  "Clans on {server}, by the National Points their members have earned.":
    "{server} sunucusundaki klanlar, üyelerinin kazandığı Ulusal Puanlara göre.",
  "National Points earned on {server} this month, minus what was lost.":
    "{server} sunucusunda bu ay kazanılan Ulusal Puanlar, kaybedilenler düşülerek.",
  "National Points earned on {server} since the start.":
    "{server} sunucusunda başlangıçtan beri kazanılan Ulusal Puanlar.",
  "No clans ranked yet. Found one at level 15 and fight for the top spot.":
    "Henüz sıralamada klan yok. 15. seviyede bir klan kur ve zirve için savaş.",
  "Nobody has earned National Points yet. The first kill in the Colony takes the top spot.":
    "Henüz kimse Ulusal Puan kazanmadı. Koloni'deki ilk öldürme zirveyi alır.",
  "Rankings could not be loaded. Try again in a moment.":
    "Sıralama yüklenemedi. Birazdan tekrar dene.",

  // ------------------------------------------------ call to action
  "Your banner is waiting": "Sancağın seni bekliyor",
  "Make a character in a minute and play in this tab.":
    "Bir dakikada karakterini oluştur ve bu sekmede oyna.",

  // ------------------------------------------------ account and sign in
  Account: "Hesap",
  "Sign in": "Giriş yap",
  "Create account": "Hesap oluştur",
  Email: "E-posta",
  Password: "Şifre",
  "Forgot your password?": "Şifreni mi unuttun?",
  or: "veya",
  "Sign in to play your characters on any device, or create an account.":
    "Karakterlerini her cihazda oynamak için giriş yap ya da bir hesap oluştur.",
  "Signed in": "Giriş yapıldı",
  "Signed in as {email}.": "{email} olarak giriş yapıldı.",
  "Signed in to your account.": "Hesabına giriş yapıldı.",
  "Sign out": "Çıkış yap",
  "Use the email and password of your account.": "Hesabının e-posta ve şifresini kullan.",
  "Choose a password you do not use anywhere else.":
    "Başka hiçbir yerde kullanmadığın bir şifre seç.",
  "Reset your password": "Şifreni sıfırla",
  "Email me a link": "Bana bağlantı gönder",
  "Enter your account's email. We send a link to choose a new password.":
    "Hesabının e-postasını gir. Yeni şifre belirlemen için bir bağlantı göndereceğiz.",
  "Back to sign in": "Girişe dön",
  "Choose a new password": "Yeni şifre belirle",
  "Save and sign in": "Kaydet ve giriş yap",
  "If {email} has an account, a link to choose a new password is on its way. It works for one hour. Check the spam folder too.":
    "{email} adresine ait bir hesap varsa yeni şifre bağlantısı yolda. Bağlantı bir saat geçerli. Spam klasörüne de bak.",

  // ------------------------------------------------ game database
  "Every monster and item in the game, straight from the game's own data.":
    "Oyundaki tüm canavarlar ve eşyalar, doğrudan oyunun kendi verisinden.",
  Monsters: "Canavarlar",
  Items: "Eşyalar",
  All: "Tümü",
  Weapons: "Silahlar",
  Armor: "Zırh",
  "Jewelry and cloaks": "Takılar ve pelerinler",
  Glows: "Parıltılar",
  "Potions and scrolls": "İksirler ve kağıtlar",
  Materials: "Malzemeler",
  "Search monsters": "Canavar ara",
  "Search items": "Eşya ara",
  Zone: "Bölge",
  "Every zone": "Tüm bölgeler",
  "Sort by": "Sırala",
  Category: "Kategori",
  "Any class": "Tüm sınıflar",
  "1 monster": "1 canavar",
  "{n} monsters": "{n} canavar",
  Monster: "Canavar",
  Where: "Nerede",
  Boss: "Boss",
  "Not placed yet": "Henüz yerleştirilmedi",
  "No monster matches.": "Eşleşen canavar yok.",
  "Restores {n} HP": "{n} HP yeniler",
  "Restores {n} MP": "{n} MP yeniler",
  "{slot}, two-handed": "{slot}, çift el",
  "Fortune stone": "Şans taşı",
  "Upgrade scroll": "Yükseltme kağıdı",
  Consumable: "Tüketilebilir",
  Material: "Malzeme",
  "1 item": "1 eşya",
  "{n} items": "{n} eşya",
  Drops: "Düşürdükleri",
  "Dropped by {mobs}": "Düşüren: {mobs}",
  "Dropped by {mobs} and {n} more": "Düşüren: {mobs} ve {n} canavar daha",
  Unique: "Eşsiz",
  "Level {n}": "Seviye {n}",
  "No item matches.": "Eşleşen eşya yok.",

  // ------------------------------------------------ header and footer
  "My profile": "Profilim",
  "The game": "Oyun",
  Classes: "Sınıflar",
  "War of Morgard": "Morgard Savaşı",
  Community: "Topluluk",
  "Humans against orcs in a free browser MMORPG. No download, runs on phones too.":
    "İnsanlar orklara karşı, ücretsiz bir tarayıcı MMORPG'sinde. İndirme yok, telefonda da çalışır.",
  "Free to play in your browser: the humans of Valcrest against the orcs of Gorzhak.":
    "Tarayıcında ücretsiz oyna: Valcrest insanları Gorzhak orklarına karşı.",

  // ------------------------------------------------ account box and profile
  "Gold Premium until {date}": "Gold Premium {date} tarihine kadar",
  "No Gold Premium": "Gold Premium yok",
  "My profile | WarCrest Online": "Profilim | WarCrest Online",
  "WarCrest Online: Free Browser MMORPG, Humans vs Orcs":
    "WarCrest Online: Ücretsiz Tarayıcı MMORPG, İnsanlar Orklara Karşı",
  "Game database: monsters and items | WarCrest Online":
    "Oyun veritabanı: canavarlar ve eşyalar | WarCrest Online",
  "Loading your account...": "Hesabın yükleniyor...",
  "You are not signed in": "Giriş yapmadın",
  "Sign in to see your account, your Gold Premium and your characters.":
    "Hesabını, Gold Premium durumunu ve karakterlerini görmek için giriş yap.",
  Active: "Aktif",
  "Until {date} ({n} days left).": "{date} tarihine kadar ({n} gün kaldı).",
  "Gold Premium gives every character on your account:":
    "Gold Premium hesabındaki her karaktere şunları verir:",
  "See the store": "Mağazaya göz at",
  Balance: "Bakiye",
  "Gems buy wings, armor skins and Gold Premium in the Power Up Store.":
    "Elmaslarla Power Up Mağazası'ndan kanat, zırh görünümü ve Gold Premium alınır.",
  "Buy gem packs in the game: open the Power Up Store.":
    "Elmas paketlerini oyunda al: Power Up Mağazası'nı aç.",
  "No armor skins yet.": "Henüz zırh görünümün yok.",
  "No characters yet. Make one in the game in a minute.":
    "Henüz karakterin yok. Oyunda bir dakikada bir tane oluştur.",
  "Member since {date}": "{date} tarihinden beri üye",
  "Game Master": "Oyun Yöneticisi",
  "Senior Game Master": "Kıdemli Oyun Yöneticisi",
  Administrator: "Yönetici",
  "Change password": "Şifreyi değiştir",
  "Privacy Policy | WarCrest Online": "Gizlilik Politikası | WarCrest Online",
  "Terms of Service | WarCrest Online": "Kullanım Şartları | WarCrest Online",
} satisfies Record<string, string>;
